import { render } from "./StreamersRulesView.vue?vue&type=template&id=812e0862&ts=true"
import script from "./StreamersRulesView.vue?vue&type=script&lang=ts"
export * from "./StreamersRulesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__